import React, { useState } from 'react';
import OverlayLoading from '../components/common/overlay-loading';
import Api from '../api/api';
import Auth from '../api/auth';
import { useNavigate } from 'react-router-dom';

const Login = props => {
    let initialForm = {
        user: '',
        pass: '',
        save: false
    }
    let savedUser = localStorage.getItem('user');
    if (savedUser) {
        savedUser = JSON.parse(savedUser);
        initialForm.user = savedUser.user;
        initialForm.pass = savedUser.pass;
        initialForm.save = true;
    }

    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState(initialForm.user);
    const [pass, setPass] = useState(initialForm.pass);
    const [factor, setFactor] = useState('');
    const [save, setSave] = useState(initialForm.save);
    const navigate = useNavigate();

    const login = async (event) => {
        event.preventDefault();

        setLoading(true)
        if (save) {
            let savedUser = {
                user: user,
                pass: pass
            }
            localStorage.setItem('user', JSON.stringify(savedUser))
        } else {
            localStorage.removeItem('user')
        }
        let req = await Api.post('auth/signin', {
            username: user,
            password: pass,
            twoFactor: factor,
        });

        if (!req.error) {
            if (req.data.resetPassword) {
                navigate('/reset');
            } else {
                Auth.saveToken(req.data.token);
                req = await Api.get('auth/me');
                if (!req.error) {
                    Auth.saveUser(req.data);
                    navigate('/dashboard');
                    return;
                }
            }
        }
        setLoading(false)
    }

    return <div>
        <OverlayLoading show={loading} />
        <div className="page-wrapper">
            <div className="container-fluid p-0">
                {/* <!-- login page start--> */}
                <div className="authentication-main" style={{
                    background: '#0A1C2C'
                }}>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="auth-innerright">
                                <div className="authentication-box">
                                    <div className="card mt-4">
                                        <div className="card-body">
                                            <div className="text-center">
                                                <h4>{"Authentication"}</h4>
                                                <h6>{"Enter your Username and Password"}</h6>
                                            </div>
                                            <form className="theme-form">
                                                <div className="form-group">
                                                    <label className="col-form-label pt-0">Username</label>
                                                    <input className="form-control"
                                                        type="text"
                                                        name="user"
                                                        value={user}
                                                        onChange={e => setUser(e.target.value)}
                                                        required />
                                                </div>
                                                <div className="form-group">
                                                    <label className="col-form-label">Password</label>
                                                    <input className="form-control"
                                                        type="password"
                                                        name="pass"
                                                        value={pass}
                                                        onChange={e => setPass(e.target.value)}
                                                        required />
                                                </div>
                                                <div className="form-group">
                                                    <label className="col-form-label">2FA</label>
                                                    <input className="form-control"
                                                        type="number"
                                                        name="factor"
                                                        value={factor}
                                                        onChange={e => setFactor(e.target.value)}
                                                        required />
                                                </div>
                                                <div className="checkbox p-0">
                                                    <input id="checkbox1"
                                                        type="checkbox"
                                                        name="save"
                                                        checked={save}
                                                        onChange={e => setSave(e.target.checked)}
                                                    />
                                                    <label htmlFor="checkbox1">RememberMe</label>
                                                </div>
                                                <div className="form-group form-row mt-3 mb-0">
                                                    <button className="btn btn-primary btn-block" type="button" onClick={login}>Login</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- login page end--> */}
            </div>
        </div>
    </div>
}

export default Login;